import React, { useState } from 'react'
import styled, { css } from 'styled-components'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'

const Wrapper = styled.div`
  width: 100%;
`
const Label = styled.label`
  display: block;
  margin-bottom: 4px;
  font-size: 12px;
  font-weight: 500;
  color: #64748B;
  font-family: Rubik;
  font-style: normal;
  line-height: 16px;
  color: ${({ hasError }) => (hasError ? '#d32f2f' : '#64748B')};
`
const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 10px;
  height: 42px;
  width: 100%;
  box-sizing: border-box;
  border-radius: 6px;
  border: 1px solid #E2E8F0;
  background: #F8FAFC;
  ${({ hasError }) =>
    hasError &&
    css`
      border-color: #d32f2f;
      background: #fff6f6;
    `}
`
const LeftIcon = styled.div`
  display: flex;
  align-items: center;
  margin-right: 0px;
  color: ${({ hasError }) => (hasError ? '#d32f2f' : '#666')};
`
const Input = styled.input`
  width: 100%;
  flex-shrink: 0;
  border: none;
  outline: none;
  font-size: 14px;
  background: ${({ hasError }) => (hasError ? '#fff6f6' : '#F8FAFC')};
  padding-left: 6px;
  min-width: 10px;

  &::placeholder {
    color: rgba(15, 23, 42, 0.50);
    font-family: Rubik;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`
const ErrorText = styled.div`
  display: flex;
  margin-top: 4px;
  font-size: 12px;
  justify-content: flex-start;
  color: #d32f2f;
`
const StyledLabel = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  align-self: stretch;
`
const StyledRequired = styled.div`
  color: #DC2626;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
`
const ContainerValue = styled.div`
  display: flex;
  height: 35px;
  padding: 8px 12px 8px 12px;
  justify-content: flex-end;
  align-items: center;
  align-self: stretch;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.30);
`

export function ValidatedPopulationInput({
  id,
  label,
  value,
  onChange,
  placeholder,
  setValidationError,
  customValidation = null,
  disabled = false,
  required = false,
  errorText,
  icon,
  dir,
}) {
  const [error, setError] = useState(false)
  return (
    <Wrapper>
      {label && (<StyledLabel htmlFor={id} hasError={error}>{label} {required && <StyledRequired>*</StyledRequired>}</StyledLabel>)}
      {disabled ? <ContainerValue>{value ?? '—'}</ContainerValue> : <InputWrapper hasError={error}>
        <LeftIcon hasError={error}>
          {error ? <ErrorOutlineIcon fontSize="small" /> : icon}
        </LeftIcon>

        <Input
          id={id}
          hasError={error}
          value={value}
          disabled={disabled}
          dir={dir}
          style={dir ? { textAlign: 'right' } : undefined}
          onChange={e => {
            if (e.target.value.trim() == '') {
              if (required) {
                setError(true)
                setValidationError(true)
              } else {
                setError(false)
                setValidationError(false)
              }
            } else if(customValidation != null) {
              const res = customValidation(e.target.value)
              if (!res) {
                setError(true)
                setValidationError(true)
              } else {
                setError(false)
                setValidationError(false)
              }
            } else {
              setError(false)
              setValidationError(false)
            }
             
            onChange(e.target.value)
          }}
          placeholder={placeholder}
        />
      </InputWrapper>}

      {error && errorText && <ErrorText>{errorText}</ErrorText>}
    </Wrapper>
  )
}

export function ValidatedInput({
  id,
  label,
  value,
  onChange,
  placeholder,
  error = false,
  errorText,
  icon
}) {
  return (
    <Wrapper>
      {label && (
        <Label htmlFor={id} hasError={error}>
          {label}
        </Label>
      )}

      <InputWrapper hasError={error}>
        <LeftIcon hasError={error}>
          {error ? <ErrorOutlineIcon fontSize="small" /> : icon}
        </LeftIcon>

        <Input
          id={id}
          value={value}
          hasError={error}
          onChange={e => onChange(e.target.value)}
          placeholder={placeholder}
        />
      </InputWrapper>

      {error && errorText && <ErrorText>{errorText}</ErrorText>}
    </Wrapper>
  )
}
